import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppConfig from "appConfig";
import { useAppLocation } from "agent_location_context";
import {
  Alert,
  Backdrop,
  Button,
  Card,
  Chip,
  CircularProgress,
  Grid,
  Icon,
  ListItem,
  ListItemText,
  Snackbar,
} from "@mui/material";

function DawRetailerPage() {
  const pageTitle = `Display & Win`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const { applocation, permissionStatus, updateAppLocation } = useAppLocation();

  const [pageLoaded, setPageLoaded] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [retailer, setRetailer] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(
          `agents/daw/retailers/${ref}/${applocation?.lat}/${applocation?.lng}/fetch.json`,
        )
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setRetailer(result.data.data.retailer);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function getUrgencyChip() {
    let text = "Ready";
    let color = "success";
    if (retailer.urgency >= 4) {
      text = "Overdue";
      color = "error";
    }

    if (retailer.urgency < 4 && retailer.urgency > 1) {
      text = "Late";
      color = "warning";
    }

    return (
      <Chip
        label={
          <MDTypography fontSize={12} color="white">
            {text}
          </MDTypography>
        }
        color={color}
      />
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox display="flex" justifyContent="space-between" mb={2}>
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    if (window.history.length > 1) {
                      window.history.back();
                    } else {
                      navigate(`/activations/display-win/${ref}`);
                    }
                  }}
                >
                  Back
                </Button>
              </MDBox>
            </MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox>
                    <ListItem divider>
                      <ListItemText
                        primary={
                          <MDTypography variant="subtitle2" fontSize={12}>
                            Name
                          </MDTypography>
                        }
                        secondary={
                          <MDTypography variant="h6" fontSize={14}>
                            {retailer.name}
                          </MDTypography>
                        }
                      />
                      <MDButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        iconOnly
                        onClick={() => {
                          window.open(`tel:${retailer.phone_number}`);
                        }}
                      >
                        <Icon>call</Icon>
                      </MDButton>
                    </ListItem>
                  </MDBox>
                  <MDBox mt={3}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <MDTypography variant="subtitle2" fontSize={12}>
                            Address
                          </MDTypography>
                        }
                        secondary={
                          <MDTypography
                            variant="h6"
                            fontWeight="regular"
                            fontSize={14}
                          >
                            {retailer.address}
                          </MDTypography>
                        }
                      />
                      <MDButton
                        variant="outlined"
                        color="error"
                        size="small"
                        iconOnly
                        onClick={() => {
                          const url = `https://maps.google.com?q=${retailer.lat},${retailer.lng}`;
                          window.open(url, "_blank").focus();
                        }}
                      >
                        <Icon>location_on</Icon>
                      </MDButton>
                    </ListItem>
                  </MDBox>
                  <MDBox mt={3}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <MDTypography variant="subtitle2" fontSize={12}>
                            Next Visit
                          </MDTypography>
                        }
                        secondary={
                          <MDTypography
                            variant="h6"
                            fontWeight="regular"
                            fontSize={14}
                          >
                            {retailer.next_visit}
                          </MDTypography>
                        }
                      />
                      <MDBox align="center">
                        {/* <MDTypography variant="subtitle2" fontSize={12}>
                          Status
                        </MDTypography> */}
                        {retailer.can_visit ? (
                          <>{getUrgencyChip()}</>
                        ) : (
                          <Chip label="Not Ready" />
                        )}
                      </MDBox>
                    </ListItem>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6} lg={6}>
                  <Card>
                    <MDBox p={2} align="center">
                      <MDTypography variant="h6" fontSize={24}>
                        {retailer.visits}
                      </MDTypography>
                      <MDTypography variant="subtitle2" fontSize={14}>
                        Visits
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Card>
                    <MDBox p={2} align="center">
                      <MDTypography variant="h6" fontSize={24}>
                        {retailer.points}
                      </MDTypography>
                      <MDTypography variant="subtitle2" fontSize={14}>
                        Points
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
            {retailer.can_visit && (
              <MDBox mt={10}>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<Icon>add_location</Icon>}
                  onClick={() =>
                    navigate(`/activations/display-win/retailers/visit/${ref}`)
                  }
                >
                  Register Visit
                </MDButton>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DawRetailerPage;
